export const cssBundleHref = "/build/css-bundle-QTO723O5.css";